import React from 'react'
import { configType } from '../../types/configType';
import moment from 'moment';

export const Privacidad = () => {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
        {/* Header */}
        <div className="border-b border-gray-200 pb-6 mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Política de Privacidad
          </h1>
          <p className="text-sm text-gray-600">
            <strong>Última actualización:</strong> <span className="bg-gray-100 px-2 py-1">26 de noviembre de 2025</span>
          </p>
        </div>

        {/* Content */}
        <div className="space-y-8 text-gray-700">

          {/* Sección 1 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Introducción</h2>
            <p className="leading-relaxed">
              La empresa <span className="bg-gray-100 px-1">NEOTEC CORPORATION S.A.C.</span>,
              con domicilio en <span className="bg-gray-100 px-1">CAL.GERMAN SCHREIBER NRO. 276 INT. 240 URB. SANTA ANA</span>, se compromete a proteger
              la privacidad y los datos personales de los usuarios que utilizan nuestro servicio de consulta de información
              del sistema a través de WhatsApp Business API.
            </p>
            <p className="leading-relaxed mt-3">
              Esta Política de Privacidad describe cómo recopilamos, usamos, almacenamos y protegemos la información
              personal en cumplimiento con las leyes de protección de datos aplicables.
            </p>
          </section>

          {/* Sección 2 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Responsable del Tratamiento de Datos</h2>
            <div className="bg-blue-50 border-l-4 border-blue-500 p-4 rounded">
              <p><strong>Razón Social:</strong> <span className="bg-gray-100 px-1">NEOTEC CORPORATION S.A.C.</span></p>
              <p><strong>Dirección:</strong> <span className="bg-gray-100 px-1">CAL.GERMAN SCHREIBER NRO. 276 INT. 240 URB. SANTA ANA</span></p>
              <p><strong>País:</strong> <span className="bg-gray-100 px-1">PERÚ</span></p>
              <p><strong>Email de contacto:</strong> <span className="bg-gray-100 px-1">contacto@neotec.pe</span></p>
              <p><strong>Teléfono:</strong> <span className="bg-gray-100 px-1">+51 1 3633864</span></p>
              <p><strong>Sitio web:</strong> <span className="bg-gray-100 px-1 hover:cursor-pointer" onClick={() => window.open('https://www.neotec.pe', '_blank')}>https://www.neotec.pe</span></p>
            </div>
          </section>

          {/* Sección 3 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Información que Recopilamos</h2>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-4">3.1 Datos de Identificación</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Número de teléfono de WhatsApp del usuario</li>
              <li>Nombre del perfil de WhatsApp (si está disponible públicamente)</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-4">3.2 Datos de Comunicación</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Contenido de los mensajes enviados por el usuario</li>
              <li>Solicitudes específicas de información del sistema</li>
              <li>Respuestas proporcionadas por nuestro sistema</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-4">3.3 Datos Técnicos y de Uso</h3>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Fecha y hora de cada interacción</li>
              <li>Registros de errores técnicos (logs)</li>
              <li>Identificadores de sesión de WhatsApp Business API</li>
              <li>Estado de entrega de mensajes</li>
            </ul>

            <div className="bg-green-50 border-l-4 border-green-500 p-4 rounded mt-4">
              <p className="font-semibold text-green-800">Importante:</p>
              <p className="text-green-700">NO recopilamos datos sensibles como información financiera, médica o credenciales de acceso.</p>
            </div>
          </section>

          {/* Sección 4 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Finalidad del Tratamiento de Datos</h2>
            <p className="mb-3">Los datos personales son procesados exclusivamente para:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Procesar y responder las solicitudes de información del usuario sobre el sistema</li>
              <li>Proporcionar acceso a los datos del sistema que el usuario consulta</li>
              <li>Mantener un registro de interacciones para soporte técnico</li>
              <li>Mejorar la funcionalidad y experiencia del servicio</li>
              <li>Cumplir con obligaciones legales y regulatorias</li>
              <li>Resolver problemas técnicos y proporcionar asistencia</li>
            </ul>

            <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded mt-4">
              <p className="font-semibold text-red-800">NO Utilizamos los Datos Para:</p>
              <ul className="list-disc list-inside space-y-1 ml-4 text-red-700">
                <li>Enviar publicidad, promociones o mensajes de marketing no solicitados</li>
                <li>Compartir o vender información a terceros con fines comerciales</li>
                <li>Crear perfiles de usuario con fines publicitarios</li>
                <li>Iniciar conversaciones sin que el usuario lo solicite primero</li>
              </ul>
            </div>
          </section>

          {/* Sección 5 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Base Legal para el Procesamiento</h2>
            <p className="mb-3">El tratamiento de datos personales se fundamenta en:</p>
            <div className="space-y-3">
              <div className="border-l-4 border-blue-400 pl-4">
                <p><strong>Consentimiento:</strong> El usuario inicia voluntariamente la conversación a través de WhatsApp, lo que constituye consentimiento expreso para el procesamiento de sus datos.</p>
              </div>
              <div className="border-l-4 border-blue-400 pl-4">
                <p><strong>Ejecución de Contrato:</strong> El procesamiento es necesario para proporcionar el servicio solicitado por el usuario.</p>
              </div>
              <div className="border-l-4 border-blue-400 pl-4">
                <p><strong>Interés Legítimo:</strong> Para mejorar nuestros servicios, proporcionar soporte técnico y garantizar la seguridad del sistema.</p>
              </div>
              <div className="border-l-4 border-blue-400 pl-4">
                <p><strong>Cumplimiento Legal:</strong> Para cumplir con obligaciones legales aplicables.</p>
              </div>
            </div>
          </section>

          {/* Sección 6 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Compartir y Divulgar Información</h2>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-4">6.1 Proveedores de Servicios Necesarios</h3>
            <p className="mb-3">Compartimos información limitada con los siguientes terceros:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li><strong>Meta Platforms, Inc. (WhatsApp):</strong> Como proveedor de la infraestructura de WhatsApp Business API. Sujeto a la Política de Privacidad de WhatsApp.</li>
              <li><strong>Proveedores de hosting:</strong> <span className="bg-gray-100 px-1">AWS y Azure</span> para almacenar datos del sistema de forma segura.</li>
              <li><strong>Proveedores de infraestructura:</strong> Para garantizar la disponibilidad y funcionamiento del servicio.</li>
            </ul>
            <p className="mt-3 text-sm italic">Todos los proveedores están contractualmente obligados a proteger la información y utilizarla únicamente para los fines autorizados.</p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-4">6.2 Requisitos Legales</h3>
            <p>Podemos divulgar información personal cuando sea requerido por ley o en respuesta a:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Órdenes judiciales o procesos legales válidos</li>
              <li>Solicitudes de autoridades gubernamentales competentes</li>
              <li>Protección de nuestros derechos legales y seguridad</li>
              <li>Prevención de fraudes o actividades ilegales</li>
            </ul>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-4">6.3 No Venta de Datos</h3>
            <p className="font-semibold">No vendemos, alquilamos ni comercializamos datos personales a terceros bajo ninguna circunstancia.</p>
          </section>

          {/* Sección 7 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Almacenamiento y Retención de Datos</h2>

            <h3 className="text-xl font-semibold text-gray-800 mb-3">7.1 Período de Retención</h3>
            <div className="bg-gray-50 p-4 rounded">
              <p className="mb-2"><strong>Mensajes y contenido de conversaciones:</strong> <span className="bg-gray-100 px-1">30 DÍAS</span> desde la última interacción</p>
              <p className="mb-2"><strong>Logs técnicos y de errores:</strong> <span className="bg-gray-100 px-1">90 DÍAS</span></p>
              <p className="mb-2"><strong>Datos necesarios para cumplimiento legal:</strong> El tiempo requerido por ley</p>
              <p><strong>Datos agregados y anonimizados:</strong> Sin límite de tiempo (no identifican a personas)</p>
            </div>
            <p className="mt-3">Los datos se eliminan automáticamente al finalizar el período de retención, salvo que exista una obligación legal de conservarlos por más tiempo.</p>

            <h3 className="text-xl font-semibold text-gray-800 mb-3 mt-4">7.2 Ubicación de los Datos</h3>
            <p>Los datos se almacenan en servidores ubicados en <span className="bg-gray-100 px-1">Estados Unidos, Unión Europea</span> proporcionados por <span className="bg-gray-100 px-1">AZURE, AWS</span>.</p>
          </section>

          {/* Sección 8 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Medidas de Seguridad</h2>
            <p className="mb-3">Implementamos medidas técnicas y organizativas para proteger los datos personales:</p>

            <div className="grid md:grid-cols-2 gap-4 mt-4">
              <div className="bg-blue-50 p-4 rounded">
                <h4 className="font-semibold mb-2">Medidas Técnicas</h4>
                <ul className="list-disc list-inside space-y-1 text-sm">
                  <li>Cifrado de datos en tránsito (TLS/SSL)</li>
                  <li>Cifrado de datos en reposo</li>
                  <li>Autenticación de dos factores</li>
                  <li>Firewalls y sistemas de detección de intrusos</li>
                  <li>Backups encriptados regulares</li>
                </ul>
              </div>
              <div className="bg-green-50 p-4 rounded">
                <h4 className="font-semibold mb-2">Medidas Organizativas</h4>
                <ul className="list-disc list-inside space-y-1 text-sm">
                  <li>Acceso restringido solo a personal autorizado</li>
                  <li>Capacitación en protección de datos</li>
                  <li>Políticas de seguridad documentadas</li>
                  <li>Auditorías de seguridad periódicas</li>
                  <li>Procedimientos de respuesta a incidentes</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Sección 9 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">9. Derechos de los Usuarios</h2>
            <p className="mb-4">De acuerdo con las leyes de protección de datos aplicables, los usuarios tienen los siguientes derechos:</p>

            <div className="space-y-3">
              <div className="border-l-4 border-purple-400 pl-4 py-2">
                <p><strong>Derecho de Acceso:</strong> Solicitar información sobre qué datos personales tenemos y cómo los procesamos.</p>
              </div>
              <div className="border-l-4 border-purple-400 pl-4 py-2">
                <p><strong>Derecho de Rectificación:</strong> Corregir datos inexactos o incompletos.</p>
              </div>
              <div className="border-l-4 border-purple-400 pl-4 py-2">
                <p><strong>Derecho de Supresión ("Derecho al Olvido"):</strong> Solicitar la eliminación de datos personales cuando ya no sean necesarios.</p>
              </div>
              <div className="border-l-4 border-purple-400 pl-4 py-2">
                <p><strong>Derecho de Portabilidad:</strong> Recibir datos en formato estructurado, de uso común y legible por máquina.</p>
              </div>
              <div className="border-l-4 border-purple-400 pl-4 py-2">
                <p><strong>Derecho de Oposición:</strong> Oponerse al procesamiento de datos personales en determinadas circunstancias.</p>
              </div>
              <div className="border-l-4 border-purple-400 pl-4 py-2">
                <p><strong>Derecho de Limitación:</strong> Solicitar la restricción del procesamiento en ciertos casos.</p>
              </div>
              <div className="border-l-4 border-purple-400 pl-4 py-2">
                <p><strong>Derecho a Retirar el Consentimiento:</strong> En cualquier momento, sin afectar la licitud del procesamiento previo.</p>
              </div>
            </div>

            <div className="bg-indigo-50 border border-indigo-200 p-4 rounded mt-4">
              <p className="font-semibold mb-2">Para ejercer estos derechos, contactar a:</p>
              <p><strong>Email:</strong> <span className="bg-gray-100 px-1">contacto@neotec.pe</span></p>
              <p><strong>Asunto:</strong> "Solicitud de Derechos de Protección de Datos"</p>
              <p className="text-sm mt-2">Responderemos a su solicitud en un plazo máximo de <span className="bg-gray-100 px-1">30 DÍAS</span> desde la recepción.</p>
            </div>
          </section>

          {/* Sección 10 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">10. Transferencias Internacionales de Datos</h2>
            <p className="mb-3">Los datos pueden ser transferidos y procesados en países fuera de <span className="bg-gray-100 px-1">PERÚ</span>, específicamente:</p>
            <ul className="list-disc list-inside space-y-2 ml-4">
              <li>Estados Unidos (Meta Platforms/WhatsApp)</li>
            </ul>
            <p className="mt-3">En tales casos, garantizamos un nivel adecuado de protección mediante:</p>
            <ul className="list-disc list-inside space-y-2 ml-4 mt-2">
              <li>Cláusulas Contractuales Estándar (SCC) aprobadas por autoridades de protección de datos</li>
              <li>Certificaciones de privacidad aplicables</li>
              <li>Cumplimiento con el Marco de Transferencia de Datos correspondiente</li>
              <li>Evaluaciones de impacto de transferencias</li>
            </ul>
          </section>

          {/* Sección 11 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">11. Uso de WhatsApp Business API</h2>
            <p className="mb-3">Este servicio utiliza la WhatsApp Business API proporcionada por Meta Platforms, Inc. El uso de WhatsApp está sujeto a sus términos y políticas.</p>
            <p className="mt-3 text-sm italic">Meta Platforms procesa ciertos datos como parte de la prestación del servicio de WhatsApp. Consulte sus políticas para más información.</p>
          </section>

          {/* Sección 12 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">12. Cookies y Tecnologías de Seguimiento</h2>
            <p>Nuestra integración con WhatsApp Business API <strong>NO utiliza cookies ni tecnologías de seguimiento</strong> en el navegador del usuario.</p>
            <p className="mt-2">Solo se utilizan identificadores técnicos estrictamente necesarios para:</p>
            <ul className="list-disc list-inside space-y-1 ml-4 mt-2">
              <li>Mantener la sesión de conversación en WhatsApp</li>
              <li>Enrutar mensajes correctamente</li>
              <li>Garantizar la entrega de respuestas</li>
            </ul>
          </section>

          {/* Sección 13 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">13. Menores de Edad</h2>
            <p className="mb-3">Nuestro servicio no está dirigido a menores de <span className="bg-gray-100 px-1">18 AÑOS</span> años.</p>
            <div className="bg-orange-50 border-l-4 border-orange-500 p-4 rounded">
              <p className="font-semibold text-orange-800 mb-2">Compromiso con la Protección de Menores:</p>
              <ul className="list-disc list-inside space-y-1 text-orange-700">
                <li>No recopilamos intencionalmente información de menores</li>
                <li>Si descubrimos que hemos recopilado datos de un menor sin consentimiento parental, los eliminaremos inmediatamente</li>
                <li>Los padres o tutores pueden contactarnos para revisar o eliminar datos de menores</li>
              </ul>
            </div>
          </section>

          {/* Sección 14 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">14. Cambios a esta Política de Privacidad</h2>
            <p className="mb-3">Nos reservamos el derecho de actualizar esta Política de Privacidad periódicamente. Los cambios serán comunicados mediante:</p>
            <div className="bg-blue-50 p-4 rounded">
              <p>• Actualización de la fecha de "Última actualización"</p>
              <p>• Notificación a través de WhatsApp para cambios sustanciales</p>
              <p>• Publicación en nuestro sitio web</p>
            </div>
          </section>

          {/* Sección 15 */}
          <section>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">18. Requisitos de WhatsApp Business API</h2>
            <div className="space-y-3">
              <div className="bg-green-50 border border-green-200 p-4 rounded">
                <p className="font-semibold text-green-800 mb-2">✓ Uso Permitido:</p>
                <ul className="list-disc list-inside space-y-1 text-green-700">
                  <li>Los usuarios siempre inician las conversaciones</li>
                  <li>Respondemos únicamente a solicitudes específicas</li>
                  <li>No enviamos mensajes no solicitados</li>
                  <li>No usamos el servicio para marketing no solicitado</li>
                </ul>
              </div>

              <div className="bg-blue-50 border border-blue-200 p-4 rounded">
                <p className="font-semibold text-blue-800 mb-2">Opt-Out:</p>
                <p className="text-blue-700">Los usuarios pueden dejar de usar el servicio:</p>
                <ul className="list-disc list-inside space-y-1 text-blue-700 mt-2">
                  <li>Bloqueando nuestro número</li>
                  <li>Enviando "STOP" o "CANCELAR"</li>
                  <li>Solicitando eliminación de datos</li>
                </ul>
              </div>
            </div>
          </section>

          {/* Aceptación */}
          <section className="border-t-2 border-gray-300 pt-6">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">Aceptación de esta Política</h2>
            <div className="bg-indigo-100 border-2 border-indigo-400 p-6 rounded-lg">
              <p className="text-lg font-semibold text-indigo-900 mb-3">Al utilizar nuestro servicio a través de WhatsApp:</p>
              <ul className="list-disc list-inside space-y-2 text-indigo-800">
                <li>Confirma haber leído esta Política</li>
                <li>Acepta el procesamiento descrito</li>
                <li>Reconoce tener la edad mínima requerida</li>
              </ul>
            </div>
          </section>

          {/* Footer */}
          <div className="text-center text-sm text-gray-500 mt-12 pt-6 border-t">
            <p className="mt-3 mb-2 text-center text-xs leading-5 text-gray-600">
              &copy; {` ${moment().year()} Titania (${configType.version})`}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}